import { i18nStore } from "./i18nStore.js";
import type { SupportedLanguage } from "@aid/shared";

export function useTranslation() {
  return {
    t: i18nStore.t,
    language: i18nStore.language,
    setLanguage: (lang: SupportedLanguage) => i18nStore.setLanguage(lang),
    loading: i18nStore.loading
  };
}
